import { DOCUMENT } from '@angular/common';
import { Injectable, inject, Renderer2, RendererFactory2 } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { APIResponse } from '../models/APIResponse';
import { RFPODReport } from '../models/rfpod-report';
import { apiV1 } from '../common/texts-constants';

@Injectable({
  providedIn: 'root'
})
export class RfpodService {
  private http = inject(HttpClient);
  private renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);
  private document = inject(DOCUMENT);


  private apiBaseUrl = environment.apiUrl+apiV1;

  GenerateProjectRFPODReport(projectId: number) {
    return this.http.get<APIResponse<RFPODReport[]>>(this.apiBaseUrl + 'RFPOD/GenerateProjectRFPODReport/' + projectId);
  }

  DownloadRFPODReports(reports: RFPODReport[]): void {
    reports.forEach((report) => {
      const bytes = this.ToUint8Array(report.fileBytes);
      if (!bytes || !report.fileName) {
        return;
      }

      const fileBuffer = new ArrayBuffer(bytes.byteLength);
      new Uint8Array(fileBuffer).set(bytes);
      const blob = new Blob([fileBuffer], { type: 'application/octet-stream' });
      const link = this.renderer.createElement('a') as HTMLAnchorElement;
      const objectUrl = this.document.defaultView?.URL.createObjectURL(blob);
      if (!objectUrl) {
        return;
      }

      link.href = objectUrl;
      link.download = report.fileName;
      link.click();

      this.document.defaultView?.URL.revokeObjectURL(objectUrl);
    });
  }

  private ToUint8Array(fileBytes: string | number[]): Uint8Array | null {
    if (Array.isArray(fileBytes)) {
      return new Uint8Array(fileBytes);
    }

    if (!fileBytes || typeof fileBytes !== 'string') {
      return null;
    }

    const sanitizedBase64 = fileBytes.includes(',') ? fileBytes.split(',').pop() ?? '' : fileBytes;
    const binary = atob(sanitizedBase64);
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    return bytes;
  }
}
